import axios from "axios";

export default function saveCurrentProgress({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({
    value,
    selectedProduct,
    id,
    locale,
    userChoiceValuesForUI,
    final_image,
    cost,
  }) => {
    const url = window.location.href;

    return axios({
      url: process.env.REACT_APP_SHARE_RECIPE_URL,
      method: "POST",
      params: { company_id: process.env.REACT_APP_KLAVIYO_PUBLIC_KEY },
      cancelToken: source.token,
      headers: {
        accept: "application/json",
        revision: "2024-05-15",
        "content-type": "application/json",
      },
      data: {
        data: {
          type: "event",
          attributes: {
            properties: {
              value: cost,
              message: url,
              finalImage: final_image,
              userChoices: userChoiceValuesForUI,
              selectedProductName: selectedProduct.name,
              productId: id,
              locale,
            },
            metric: {
              data: {
                type: "metric",
                attributes: { name: "Abandoned MyBauer" },
              },
            },
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: value,
                },
              },
            },
          },
        },
      },
    });
  };
}
